module.exports = __webpack_public_path__ + "static/media/qld.263f5703.png";